// extracted by mini-css-extract-plugin
export var contentContainer = "ExperienceSection-module--contentContainer--1d15e";
export var divider = "ExperienceSection-module--divider--fa63c";
export var experienceContent = "ExperienceSection-module--experienceContent--5f327";
export var experienceContentContainer = "ExperienceSection-module--experienceContentContainer--6e364";
export var experienceImage = "ExperienceSection-module--experienceImage--715dc";
export var experienceImageContainer = "ExperienceSection-module--experienceImageContainer--de2ea";
export var experienceItem = "ExperienceSection-module--experienceItem--21a9c";
export var experienceItemTitle = "ExperienceSection-module--experienceItemTitle--9616e";
export var experienceItemsContainer = "ExperienceSection-module--experienceItemsContainer--7461b";
export var extraKickerStyling = "ExperienceSection-module--extraKickerStyling--e5b23";
export var reverseImage = "ExperienceSection-module--reverseImage--d9e6e";
export var reverseItem = "ExperienceSection-module--reverseItem--ea832";
export var sectionColor = "ExperienceSection-module--sectionColor--3c5f8";